var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-group-items",class:{ error: _vm.error }},[_vm._t("default"),_c('button',{staticClass:"action",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("Change")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }